export default "__VITE_ASSET__DDmKwvZY__"